import React from 'react'

const Footer = () => {
  return (
    <footer>
       <div className="footer-container container">Copyright ©2022 All rights reserved.</div>
    </footer>
  )
}

export default Footer